import ApiService from "../services/api";

const partnerMock = [
    {
        id: "e223c062-adeb-4346-b4ba-e6783d760f66",
        name: "Chame|Volks - Allianz"
    },
]

export const fetchPartners = async (): Promise<{ id: string, name: string }[]> => {
    const apiService = new ApiService();
    try {
        throw new Error("teste");
        const response = await apiService.get<any[]>("/partner");
        return response.data.map((partner: any) => ({
            id: partner.id, 
            name: partner.name
        }));
    } catch (error) {
        console.error(error);
        return partnerMock;
    }
};

export const fetchPartner = async (id: string): Promise<{ id: string, name: string } | undefined> => {
    const apiService = new ApiService();
    try {
        throw new Error("teste");
        const response = await apiService.get<any>(`/partner/${id}`);
        return { id: response.data.id, name: response.data.name };
    } catch (error) {
        console.error(error);
        return partnerMock.find((partner) => partner.id === id);
    }
};